import { ILinearProgressBarStyle } from '../models/index.js';
export const linearProgressBarStyle: ILinearProgressBarStyle = {
	children: {
		bar: {
			width: '400px',
			height: '15px',
			border: {
				radius: '10px',
			},
		},
	},
};
